import {ApplicationConfiguration} from './application-configurations';
import {baseBackendConfiguration, baseFrontendConfiguration} from './base-environment';
import {buildInfo} from './build-info';

export const environment: ApplicationConfiguration = {
  production: false,
  name: 'dev-test',
  oidc: {
    authority: "https://cognito-idp.eu-west-1.amazonaws.com/eu-west-1_pazyLodKK",
    client_id: "70diqsjf9b77slmne73k1l16f",
    redirect_uri: "https://app.devtest.pxcatclaim.com/callback",
    post_logout_redirect_uri: "https://app.devtest.pxcatclaim.com/",
    response_type: "code",
    scope: "profile email openid",
    automaticSilentRenew: true,
    loadUserInfo: true
  },
  session: {
    idleTimeoutMinutes: 15,
    warningSeconds: 120
  },
  claimManagerBackend: {
    ...baseBackendConfiguration,
    baseUrl: 'https://api.devtest.pxcatclaim.com',
  },
  claimManagerFrontend: {
    ...baseFrontendConfiguration,
    baseUrl: 'https://app.devtest.pxcatclaim.com',
  },
  buildInfo: {
    commitId: buildInfo.commitId,
    buildDate: buildInfo.buildDate,
    version: buildInfo.version
  }
};
